import { INVITE_STEP, REQUIRE_ROLE_FOR_MEMBER } from '../constants/inviteRules.js';
import { USER_TYPE } from '../constants/copy.js';
import { parseEmails } from './parseEmails.js';

const MEMBER_STEPS = Object.freeze([
  INVITE_STEP.PEOPLE,
  INVITE_STEP.ROLES,
  INVITE_STEP.GROUPS,
  INVITE_STEP.REVIEW,
]);
const ADMIN_STEPS = Object.freeze([INVITE_STEP.PEOPLE, INVITE_STEP.REVIEW]);

/**
 * Ordered step ids of the invite builder. A Member picks roles and groups; an Admin gets every
 * studio, so Roles and Groups are skipped. The only place that knows the sequence.
 *
 * @param {string} userType One of `USER_TYPE`.
 */
export const getInviteSteps = (userType) =>
  userType === USER_TYPE.ADMIN ? ADMIN_STEPS : MEMBER_STEPS;

export const getNextStep = (userType, stepId) => {
  const steps = getInviteSteps(userType);
  return steps[steps.indexOf(stepId) + 1] ?? null;
};

export const getPreviousStep = (userType, stepId) => {
  const steps = getInviteSteps(userType);
  const index = steps.indexOf(stepId);
  return index > 0 ? steps[index - 1] : null;
};

/**
 * Whether the user may leave `stepId` forward. `reason` is a key under `invite.blocked.*`.
 *
 * @param {string} stepId
 * @param {{ emails: string[], draft?: string, userType: string, roleIds: string[] }} state
 * @param {{ requireRole?: boolean }} [rules]
 * @returns {{ ok: true } | { ok: false, reason: string }}
 */
export const canLeaveStep = (
  stepId,
  { emails, draft = '', userType, roleIds },
  { requireRole = REQUIRE_ROLE_FOR_MEMBER } = {},
) => {
  // An address typed but not yet confirmed counts: Next confirms it.
  const hasPeople = emails.length > 0 || parseEmails(draft).valid.length > 0;
  if (stepId === INVITE_STEP.PEOPLE && !hasPeople) return { ok: false, reason: 'noEmails' };
  if (
    stepId === INVITE_STEP.ROLES &&
    requireRole &&
    userType === USER_TYPE.MEMBER &&
    roleIds.length === 0
  ) {
    return { ok: false, reason: 'noRole' };
  }
  return { ok: true };
};
